import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SeoService } from '../../seo.services';

@Component({
  selector: 'app-diarrea',
  templateUrl: './diarrea.component.html',
  styleUrls: []
})
export class DiarreaComponent implements OnInit {

  constructor(private title: Title, private seo: SeoService) { }

  ngOnInit() {
  	let t:string ="¿Tienes diarrea? Sinuberase ayuda a disminuir la frecuencia y duración";
  	this.title.setTitle(t);

  	this.seo.generateTags({
  		title:"Sinuberase cuenta con una presentación que se adapta a cada paciente",
  		description: "Se han publicado estudios clínicos que muestran resultados consistentes, sugiriendo que los probióticos son seguros y eficaces contra la diarrea",
  		slug: "Diarrea"
  	})

  	this.seo.closeMenu();
  }

}
